import { render, staticRenderFns } from "./ListEditor.vue?vue&type=template&id=828895a4"
import script from "./ListEditor.vue?vue&type=script&lang=ts"
export * from "./ListEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports